import React from 'react';

/**
 * Input Component
 * 
 * A reusable input component styled according to Zamanat design system
 * 
 * @param {Object} props
 * @param {string} props.label - Input label
 * @param {boolean} props.required - Whether input is required
 * @param {string} props.error - Error message
 * @param {string} props.type - Input type
 * @param {string} props.placeholder - Input placeholder
 * @param {string} props.className - Additional CSS classes
 */
const Input = React.forwardRef(({
  label,
  required = false,
  error,
  type = 'text',
  placeholder,
  className = '',
  ...props
}, ref) => {
  const inputClasses = [
    'input',
    error && 'input-error',
    className,
  ].filter(Boolean).join(' ');
  
  return (
    <div className="w-full">
      {label && (
        <label className={`label ${required ? 'label-required' : ''}`}>
          {label}
        </label>
      )}
      <input
        ref={ref}
        type={type}
        placeholder={placeholder}
        className={inputClasses}
        {...props}
      />
      {error && (
        <p className="mt-2 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;

